import { render, staticRenderFns } from "./FullScreenFrame.vue?vue&type=template&id=e4cd9886&scoped=true&"
import script from "./FullScreenFrame.vue?vue&type=script&lang=js&"
export * from "./FullScreenFrame.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenFrame.vue?vue&type=style&index=0&id=e4cd9886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cd9886",
  null
  
)

export default component.exports